 import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CreateBlogContent = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "Environment",
    tags: "",
    authorName: "",
    image: null
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const categories = ["Environment","Social Work","Education","Health","Community"];

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    setFormData(prev => ({...prev, authorName: isAdmin? "Admin" : ""}))
  }, [isAdmin])

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({...formData, image: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if(!formData.title ||!formData.description ||!formData.image) {
      setError("Title, Description and Image are required");
      setLoading(false);
      return;
    }

    const data = new FormData();
    Object.keys(formData).forEach(key => {
      if(formData[key]) data.append(key, formData[key]);
    });

    try {
      const token = localStorage.getItem("token");

      const apiUrl = isAdmin
    ? "/api/blogs/admin"
        : "/api/blogs/user";

      const res = await axios.post(apiUrl, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });

      setSubmitted(true);
      alert(res.data.message || "Blog submitted successfully!");
      setTimeout(() => navigate("/blog"), 1500);
    } catch (err) {
      setError(err.response?.data?.message || "Error uploading blog!");
      alert(err.response?.data?.message || "Error uploading blog!");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
.create-blog-container { max-width: 1200px; margin: 40px auto; padding: 20px; }
.create-blog-title { text-align: center; color: #2e7d32; margin-bottom: 10px; font-size: 36px; font-weight: 800; }
.create-blog-subtitle { text-align: center; color: #666; margin-bottom: 30px; font-size: 16px; }
.categories-wrapper { display: flex; gap: 15px; justify-content: center; flex-wrap: wrap; margin-bottom: 30px; }
.category-btn { padding: 12px 25px; border-radius: 10px; cursor: pointer; font-weight: bold; transition: 0.3s; white-space: nowrap; }
.main-grid { display: grid; grid-template-columns: 2fr 1fr; gap: 25px; }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px; }
.card { background: #fff; padding: 25px; border-radius: 15px; box-shadow: 0 8px 20px rgba(0,0,0,.08); box-sizing: border-box; width: 100%; }
.input-field,.textarea-field { width: 100%; padding: 12px; margin-top: 8px; border-radius: 8px; border: 1px solid #ddd; box-sizing: border-box; font-family: 'Poppins', sans-serif; }
.btn-disabled { opacity: 0.6; cursor: not-allowed!important; }
        @media (max-width: 900px) {.main-grid { grid-template-columns: 1fr; } }
        @media (max-width: 600px) {.create-blog-container { margin: 20px auto; padding: 15px; }.create-blog-title { font-size: 24px; }.form-grid { grid-template-columns: 1fr; }.card { padding: 18px; }.category-btn { padding: 10px 16px; font-size: 13px; } }
      `}</style>

      <div className="create-blog-container">
        <h1 className="create-blog-title">{isAdmin? "Create Blog - Admin" : "Share Your Story"}</h1>
        <p className="create-blog-subtitle">{isAdmin? "Publish directly" : "Submit for review"}</p>
        {error && <p style={{color: 'red', textAlign: 'center', fontWeight: 600}}>{error}</p>}

        <div className="categories-wrapper">
          {categories.map((cat) => (
            <div key={cat} onClick={() => setFormData({...formData, category: cat })}
              className="category-btn"
              style={{ background: formData.category === cat? "#2e7d32" : "#e8f5e9", color: formData.category === cat? "#fff" : "#2e7d32" }}>
              {cat}
            </div>
          ))}
        </div>

        <div className="main-grid">
          <div>
            <form onSubmit={handleSubmit} className="card">
              <div className="form-grid">
                <div>
                  <label style={{fontWeight: "600"}}>Blog Title *</label>
                  <input type="text" name="title" placeholder="Enter blog title" required value={formData.title} onChange={handleChange} className="input-field" />
                </div>
                <div>
                  <label style={{fontWeight: "600"}}>Author Name</label>
                  <input type="text" name="authorName" placeholder="Your Name" required={!isAdmin} value={formData.authorName} onChange={handleChange} className="input-field" />
                </div>
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label style={{fontWeight: "600"}}>Tags</label>
                <input type="text" name="tags" placeholder="nature, climate" value={formData.tags} onChange={handleChange} className="input-field" />
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label style={{fontWeight: "600"}}>Description *</label>
                <textarea name="description" rows="7" required placeholder="Write your story..." value={formData.description} onChange={handleChange} className="textarea-field" />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{fontWeight: "600"}}>Upload Blog Image *</label>
                <input type="file" name="image" accept="image/*" required onChange={handleImage} style={{ width: "100%", marginTop: "10px" }} />

                {imagePreview &&
                  <img
                    src={imagePreview}
                    alt="preview"
                    style={{width: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px', marginTop: '10px'}}
                  />
                }
                {formData.image &&!imagePreview && <p style={{fontSize: "12px", color: "green", marginTop: "5px"}}>Selected: {formData.image.name}</p>}
              </div>

              <button type="submit" disabled={loading} className={`input-field ${loading? 'btn-disabled' : ''}`} style={{background: "#2e7d32", color: "#fff", fontWeight: "bold", border: "none", cursor: "pointer", fontSize: "16px"}}>
                {loading? "Submitting..." : isAdmin? "Publish Blog" : "Submit for Review"}
              </button>

              {submitted && <p style={{ color: "green", marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>✅ {isAdmin? "Blog Published!" : "Submitted for Review!"} Redirecting...</p>}
            </form>
          </div>

          <div>
            <div className="card" style={{borderLeft: `4px solid ${isAdmin? "#2e7d32" : "#ff9800"}`}}>
              <h3 style={{ color: isAdmin? "#2e7d32" : "#ff9800", marginTop: "0" }}>{isAdmin? "Admin Note" : "User Note"}</h3>
              <ul style={{ marginTop: "20px", lineHeight: "2", color: "#555", paddingLeft: "20px" }}>
                {isAdmin? (
                  <>
                    <li>This blog will be "Approved" directly</li>
                    <li>It will show on blog page immediately</li>
                  </>
                ) : (
                  <>
                    <li>This blog will go to "Pending"</li>
                    <li>Admin will approve it before showing</li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBlogContent;